module.exports = __webpack_public_path__ + "media/recipes/80-19bf16e0.png";